<template>
  <div class="userSourcePage" v-if="!showLoad">
    <van-sticky class="Header">
      <van-cell-group class="ageMouth">
        <van-field v-model="ageMouth" readonly is-link @click="TimePicker" />
      </van-cell-group>
    </van-sticky>
    <div class="info">
      <div class="userInfo ggInfo">
        <h4 class="tit">入职</h4>
        <ul>
          <li class="clearfix">
            <label>时间</label>
            <span class="itemInfo">{{ userinfo.employedDate }}</span>
          </li>
          <li class="clearfix">
            <label>部门</label>
            <span class="itemInfo">{{ userinfo.departmentName }}</span>
          </li>
          <li class="clearfix">
            <label>职位</label>
            <span class="itemInfo">{{ userinfo.positionName }}</span>
          </li>
        </ul>
        <!-- </van-cell-group> -->
      </div>
      <div class="kaoqin ggInfo" v-if="chartDataShow">
        <h4 class="tit">考勤</h4>
        <div>
          <ve-bar
            :data="chartData"
            :settings="attendanceSettings"
            :extend="attendanceExtend"
            :legend-visible="false"
            height="300px"
          ></ve-bar>
        </div>
      </div>
      <div class="material ggInfo">
        <h4 class="tit">资产</h4>
        <div class="container">
          <ul>
            <li
              class="clearfix"
              v-for="(item, index) in materialList"
              :key="index"
            >
              <label>领用</label>
              <span class="itemInfo">{{ item.materialName }}</span>
              <span
                :class="['fr', item.isReturn == true ? 'isTrue' : 'isFalse']"
                >{{ item.isReturn == true ? "已还" : "未还" }}</span
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="project ggInfo" v-if="projectTotal != '0'">
        <h4 class="tit clearfix">
          项目
          <span class="fr">{{ projectTotal }} 个</span>
        </h4>
        <div class="container">
          <ve-ring
            :data="projectChartData"
            :settings="projectSettings"
            height="260px"
            width="100%"
          ></ve-ring>
        </div>
      </div>
      <div
        class="reimburse ggInfo"
        v-if="reimburseChartData.rows.length != '0'"
      >
        <h4 class="tit clearfix">
          报销
          <span class="fr">{{ reimburseTotal }} 元</span>
        </h4>
        <div class="container">
          <ve-histogram
            :data="reimburseChartData"
            :legend-visible="false"
            :settings="reimburseSettings"
          ></ve-histogram>
        </div>
      </div>
      <div class="apply ggInfo" v-if="applyChartData.rows.length != '0'">
        <h4 class="tit">申请</h4>
        <div class="container">
          <ve-ring
            :data="applyChartData"
            height="260px"
            width="100%"
            :settings="applySettings"
          ></ve-ring>
        </div>
      </div>
      <div class="apply ggInfo" v-if="auditChartData.rows.length != '0'">
        <h4 class="tit">审核</h4>
        <div class="container">
          <ve-ring
            :data="auditChartData"
            height="260px"
            width="100%"
            :settings="auditSettings"
          ></ve-ring>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
  </div>
</template>
<script>
/* eslint-disable */
import Vue from "vue";
import VCharts from "v-charts";
import "echarts/lib/component/title";
Vue.use(VCharts);
import { mapState, mapMutations } from "vuex";
import { dateTimeFormat } from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "userSourcePage",
  data() {
    this.attendanceExtend = {
      series: {
        barWidth: 20,
      },
      xAxis: {
        axisLine: {
          show: false,
        },
        // x轴对应的竖线
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
          textStyle: {
            color: "#666", //x轴字体颜色
            fontSize: "13px",
          },
        },
      },
    };
    this.attendanceSettings = {
      labelMap: {
        typeName: "类型",
        count: "次数",
      },
    };

    this.projectSettings = {
      labelMap: {
        日期: "我参与的",
        访问用户: "我负责的",
      },
      radius: [50, 80],
      offsetY: 130,
      label: {
        show: false,
      },
      labelLine: {
        show: false,
      },
    };

    this.reimburseSettings = {
      labelMap: {
        dictName: "类型",
        amount: "金额",
      },
    };
    this.applySettings = {
      labelMap: {
        typeName: "状态",
        count: "数量",
      },
      radius: [50, 80],
      offsetY: 160,
    };
    this.auditSettings = {
      labelMap: {
        typeName: "状态",
        count: "数量",
      },
      radius: [50, 80],
      offsetY: 160,
    };
    return {
      baseUrl: process.env.BASE_URL,
      ageMouth: "",
      materialList: "", //资产列表
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2000, 1, 1),
      chartDataShow: true,
      chartData: {
        //考勤
        columns: ["typeName", "count"],
        rows: [
          { typeName: "迟到", count: 0 },
          { typeName: "请假", count: 0 },
          { typeName: "签到", count: 0 },
          { typeName: "签退", count: 0 },
          { typeName: "出差", count: 0 },
          { typeName: "早退", count: 0 },
        ],
      },
      projectTotal: "", //项目统计
      projectChartData: {
        //项目
        columns: ["type", "count"],
        rows: [
          { type: "我参与的", count: 0 },
          { type: "我负责的", count: 0 },
        ],
      },
      reimburseTotal: "", //报销统计
      reimburseChartData: {
        //报销
        columns: ["dictName", "amount"],
        rows: [],
      },
      applyChartData: {
        //申请
        columns: ["typeName", "count"],
        rows: [],
      },
      auditChartData: {
        //申请
        columns: ["typeName", "count"],
        rows: [],
      },
    };
  },
  mounted() {
    if (this.userinfo && this.userinfo.id) {
      this.setShowLoad(false); //加载状态，默认为true加载
      this.ageMouth = dateTimeFormat(new Date()).substring(0, 7);
      this.userinfo.positionName =
        this.userinfo.positionName == null ? "" : this.userinfo.positionName;
      this.initPage();
    }
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initPage() {
      this.auditChartData.rows = [];
      this.applyChartData.rows = [];
      this.reimburseChartData.rows = [];
      this.chartData.rows = [
        { typeName: "迟到", count: 0 },
        { typeName: "请假", count: 0 },
        { typeName: "签到", count: 0 },
        { typeName: "签退", count: 0 },
        { typeName: "出差", count: 0 },
        { typeName: "早退", count: 0 },
      ];
      this.projectChartData.rows = [
        { type: "我参与的", count: 0 },
        { type: "我负责的", count: 0 },
      ];
      this.getCentreApply(); //申请统计
      this.getCentreAttendance(); //考勤统计
      this.getCentreAudit(); //审核统计
      this.getCentreMaterial(); //资产统计
      this.getCentreProject(); //项目统计
      this.getCentreReimburse(); //报销统计
    },
    TimePicker() {
      this.showTimePicker = true;
    },
    onTimeConfirm(data) {
      this.showTimePicker = false;
      this.ageMouth = dateTimeFormat(data).substring(0, 7);
      this.initPage();
    },

    getCentreAttendance() {
      //考勤
      let _this = this;
      _this.$api.userCenter.user.userInfo
        .dataCentreAttendance({ dateDto: this.ageMouth })
        .then((res) => {
          if (res.code == "1") {
            let AttendanceType = true;
            _this.chartData.rows[0].count = res.data.cdCount;
            _this.chartData.rows[1].count = res.data.leaveCount;
            _this.chartData.rows[2].count = res.data.qdCount;
            _this.chartData.rows[3].count = res.data.qtCount;
            _this.chartData.rows[4].count = res.data.travelCount;
            _this.chartData.rows[5].count = res.data.ztCount;
            for (let i = 0; i < _this.chartData.rows.length; i++) {
              if (_this.chartData.rows[i].count != "0") {
                AttendanceType = false;
                break;
              }
            }
            _this.chartDataShow = !AttendanceType;
            console.log(AttendanceType);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getCentreMaterial() {
      //资产
      let _this = this;
      _this.$api.userCenter.user.userInfo
        .dataCentreMaterial({
          nature: "gdzc",
        })
        .then((res) => {
          if (res.code == "1") {
            _this.materialList = res.data;
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getCentreProject() {
      //项目统计
      let _this = this;
      _this.$api.userCenter.user.userInfo
        .dataCentreProject({ dateDto: this.ageMouth })
        .then((res) => {
          if (res.code == "1") {
            _this.projectChartData.rows[0].count = res.data.cyCount;
            _this.projectChartData.rows[1].count = res.data.fzCount;

            _this.projectTotal =
              parseFloat(res.data.cyCount) + parseFloat(res.data.fzCount);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getCentreReimburse() {
      //报销统计接口
      let _this = this;
      _this.$api.userCenter.user.userInfo
        .dataCentreReimburse({ dateDto: this.ageMouth })
        .then((res) => {
          if (res.code == "1") {
            let num = 0;
            res.data.forEach((item) => {
              if (item.amount != "0") {
                num = num + Number(item.amount);
                _this.reimburseChartData.rows.push(item);
              }
            });

            this.reimburseTotal = num.toFixed(2);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getCentreApply() {
      //申请统计
      let _this = this;
      _this.$api.userCenter.user.userInfo
        .dataCentreApply({ dateDto: this.ageMouth })
        .then((res) => {
          if (res.code == "1") {
            res.data.forEach((item) => {
              item.typeName = this.getTypeName(item.verifyStatus);
            });
            this.$set(this.applyChartData, "rows", res.data);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //获取typeName
    getTypeName(type) {
      let name = "";
      if (type == "hold") {
        name = "草稿";
      } else if (type == "pending") {
        name = "待审批";
      } else if (type == "doing") {
        name = "审批中";
      } else if (type == "pass") {
        name = "审批通过";
      } else if (type == "deny") {
        name = "审批不通过";
      } else {
        name = "";
      }
      return name;
    },
    getCentreAudit() {
      //审核统计
      let _this = this;
      _this.$api.userCenter.user.userInfo
        .dataCentreAudit({ dateDto: this.ageMouth })
        .then((res) => {
          if (res.code == "1") {
            res.data.forEach((item) => {
              item.typeName = this.getAuditName(item.buttonCode);
            });
            this.$set(this.auditChartData, "rows", res.data);
            console.log("1111===" + JSON.stringify(this.auditChartData));
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //获取typeName
    getAuditName(type) {
      let name = "";
      if (type == "pass") {
        name = "通过";
      } else if (type == "reject") {
        name = "不通过";
      } else if (type == "pending") {
        name = "待审核";
      } else {
        name = "";
      }
      return name;
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        this.setShowLoad(false); //加载状态，默认为true加载
        this.ageMouth = dateTimeFormat(new Date()).substring(0, 7);
        this.initPage();
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.userSourcePage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow: hidden;
  .info {
    width: 100%;
    padding: 0 10px;
    height: 90%;
    overflow-y: scroll;
  }
  .ageMouth {
    height: 10%;
    .van-field__control {
      text-align: center;
      font-size: 15px;
      color: #666;
    }
  }
  h4.tit {
    font-size: 16px;
    color: #4e4e4e;
    font-family: "PingFangSC-Medium", "PingFang SC";
    font-weight: 500;
    height: 100%;
    line-height: 45px;
    font-weight: 600;
    border-bottom: 1px solid #eee;
  }
  .ggInfo {
    width: 100%;
    padding: 16px 14px;
    margin: 14px 0;
    background-color: #fff;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
  }

  .baseNone::after {
    content: none;
  }
  .baseNone {
    .van-cell__title {
      span {
        font-size: 13px;
        font-family: "PingFangSC-Regular", "PingFang SC";
        color: #aaa;
        line-height: 22px;
      }
    }
    .van-field__body {
      .van-field__control {
        text-align: left;
        font-size: 13px;
        font-family: "PingFangSC-Regular", "PingFang SC";
        color: #333;
        line-height: 22px;
      }
    }
    .ggInput {
      padding: 10px 0;
    }
  }
  .baseNone .ggInput::after {
    content: none;
  }
  p.fgx {
    width: 100%;
    height: 12px;
    background-color: #f5f6f8;
  }
  //资产
  .material {
    ul {
      li {
        margin: 10px 0;
        label {
          font-size: 13px;
          font-family: "PingFangSC-Regular", " PingFang SC";
          font-weight: 400;
          color: #aaaa;
          line-height: 22px;
        }
        span {
          display: inline-block;
          font-size: 13px;
          font-family: "PingFangSC-Regular", " PingFang SC";
          color: #000;
          line-height: 22px;
        }
        .itemInfo {
          margin-left: 12px;
          font-size: 13px;
          color: #000;
        }
        span.isTrue {
          color: #4cbc84;
        }
        span.isFalse {
          color: #ed5d4a;
        }
      }
    }
  }
  //项目
  .ggInfo {
    .container {
      margin-top: 10px;
    }
  }
  .userInfo {
    ul {
      li {
        margin: 10px 0;
        label {
          font-size: 13px;
          font-family: "PingFangSC-Regular", " PingFang SC";
          font-weight: 400;
          color: #aaaa;
          line-height: 22px;
        }
        span {
          display: inline-block;
          margin-left: 20px;
          font-size: 13px;
          font-family: "PingFangSC-Regular", " PingFang SC";
          color: #000;
          line-height: 22px;
        }
      }
    }
  }
}
</style>